export default __webpack_public_path__ + "static/media/organize_stuff.887efeaf.png";